import { useEffect } from "react";
import { useCartContext } from "context/cart-context";
import { useAppContext } from "context/app-context";
import { Loader } from "components/UI/atoms";
import { CartExpired, CartHeader, CartShipping } from "components/UI/molecules";
import {
  CartGuarantee,
  CartItemList,
  CartSummary
} from "components/UI/organisms";
import { setReturnToCookie } from "services/cookies";
import "./index.scss";

export const Cart = () => {
  const {
    sessionInfo: {
      isDeviceVerified,
      featureToggles: { isUnifiedCart }
    }
  } = useAppContext();
  const { cart } = useCartContext();

  useEffect(() => {
    if (isDeviceVerified) return;

    setReturnToCookie(window.location.href);
  }, [isDeviceVerified]);

  const isReady = !cart.isCartLoading || cart.isInitialCardsLoaded;

  useEffect(() => {
    if (!cart.isCartLoading) return;
    window.scrollTo(0, 0);
  }, [cart.isCartLoading]);

  if (!isReady) return null;

  if (cart.isCartLoading)
    return <Loader variant="secondary" id="page-loader" />;

  return (
    <div className="cart">
      <CartHeader />
      <div className="cart-columns">
        <div className="left-column">
          {cart.timeIsUp && <CartExpired />}
          {!!cart.cards && (
            <CartItemList
              isUnifiedCart={isUnifiedCart}
              cards={cart.cards}
              {...cart}
            />
          )}
        </div>
        <div className="right-column">
          <CartSummary isUnifiedCart={isUnifiedCart} {...cart} />
          <CartGuarantee />
        </div>
      </div>
      <CartShipping />
    </div>
  );
};
